module.exports = __webpack_public_path__ + "img/icon-13.c76ad53d.png";